import type { Coordinate } from '../coordinates.model';

/** Canonical mock {@link Coordinate} (Dubai Mall). */
export const MOCK_COORDINATE: Coordinate = {
  longitude: 55.2744,
  latitude: 25.1972,
};

/** Builds a {@link Coordinate} from {@link MOCK_COORDINATE} with overrides. */
export function createMockCoordinate(
  overrides?: Partial<Coordinate>
): Coordinate {
  return { ...MOCK_COORDINATE, ...overrides };
}

/**
 * Builds a closed polygon of {@link Coordinate}s suitable for industrial
 * area boundaries. Defaults to a small square centered on
 * {@link MOCK_COORDINATE}.
 */
export function createMockCoordinatePolygon(
  size = 0.05,
  center: Coordinate = MOCK_COORDINATE
): Coordinate[] {
  return [
    { longitude: center.longitude - size, latitude: center.latitude - size },
    { longitude: center.longitude + size, latitude: center.latitude - size },
    { longitude: center.longitude + size, latitude: center.latitude + size },
    { longitude: center.longitude - size, latitude: center.latitude + size },
    { longitude: center.longitude - size, latitude: center.latitude - size },
  ];
}
